import React from 'react';
import pluralize from 'pluralize';

import type { Timeline } from '../../types/timeline';

const TimelineCardStats: React.FC<{ timeline: Timeline }> = ({ timeline }) => {
  return (
    <div className="timeline-card-stats wa-cluster wa-gap-m">
      <div id={`timeline-${timeline.id}-reactions`} className="wa-cluster wa-gap-2xs">
        <i className="fa-light fa-heart timeline-card-stat-icon" />
        <span className="timeline-card-stat">{timeline.stats.total_reactions}</span>
        <wa-tooltip for={`timeline-${timeline.id}-reactions`} placement="top">
          {pluralize('reaction', timeline.stats.total_reactions, true)}
        </wa-tooltip>
      </div>
      <div id={`timeline-${timeline.id}-comments`} className="wa-cluster wa-gap-2xs" title="Comments">
        <i className="fa-light fa-comment timeline-card-stat-icon" />
        <span className="timeline-card-stat">{timeline.stats.total_comments}</span>
        <wa-tooltip for={`timeline-${timeline.id}-comments`} placement="top">
          {pluralize('comment', timeline.stats.total_comments, true)}
        </wa-tooltip>
      </div>
      <div id={`timeline-${timeline.id}-views`} className="wa-cluster wa-gap-2xs">
        <i className="fa-light fa-eye timeline-card-stat-icon" />
        <span className="timeline-card-stat">{timeline.stats.total_views}</span>
        <wa-tooltip for={`timeline-${timeline.id}-views`} placement="top">
          {pluralize('view', timeline.stats.total_views, true)}
        </wa-tooltip>
      </div>
      <div id={`timeline-${timeline.id}-shares`} className="wa-cluster wa-gap-2xs">
        <i className="fa-light fa-share timeline-card-stat-icon" />
        <span className="timeline-card-stat">{timeline.stats.total_shares}</span>
        <wa-tooltip for={`timeline-${timeline.id}-shares`} placement="top">
          {pluralize('share', timeline.stats.total_shares, true)}
        </wa-tooltip>
      </div>
    </div>
  );
}

export default TimelineCardStats;
